import { render } from "./OrgUsageStatBarGraphs.vue?vue&type=template&id=36af3f3c&scoped=true&ts=true"
import script from "./OrgUsageStatBarGraphs.vue?vue&type=script&lang=ts"
export * from "./OrgUsageStatBarGraphs.vue?vue&type=script&lang=ts"

import "./OrgUsageStatBarGraphs.vue?vue&type=style&index=0&id=36af3f3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36af3f3c"]])

export default __exports__